import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';
import { InlineIcon } from '../inline-icon/inline-icon';
import ArrowDownIcon from '../../icons/compiled/components/ArrowDownIcon';
export class Select extends React.Component {
    render() {
        const { options, disabled, dataHook, className, ariaLabel, onChange, selected, isRTL, } = this.props;
        const arrowDownStyles = classNames(styles.arrowDown, {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        });
        return (React.createElement("div", { className: `${styles.wrapper} ${className}`, "aria-label": ariaLabel },
            React.createElement(InlineIcon, { className: arrowDownStyles, icon: React.createElement(ArrowDownIcon, null) }),
            React.createElement("select", { "data-hook": dataHook, className: styles.select, onChange: onChange, value: selected || '', disabled: disabled }, options.map((opt) => (React.createElement("option", { key: opt.value, value: opt.value }, opt.text))))));
    }
}
Select.defaultProps = {
    options: [],
    onChange: () => { },
    disabled: false,
    isRTL: false,
};
//# sourceMappingURL=select.js.map